import { WidgetConfig } from '../../components/elements/Draggable';
import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

interface GetChart {
  StartDate: string;
  EndDate: string;
}

interface GetMostCourses extends GetChart {
  CategoryId: string;
}

interface NEWChartPlan extends GetChart {
  Month?: string;
  Year?: string;
  SubBuName?: string;
  DeptName?: string;
  BinusianId?: string;
  BuCode?: string;
  SubBuCode?: string;
  DeptCode?: string;
}

interface GetChartPlan extends GetChart {
  Bulan?: string;
  Tahun?: string;
  Year?: string;
  Month?: string;
  BuName?: string;
  SubBuName?: string;
  BinusianId?: string;
  DeptName?: string;
  Role?: string;
  bulan?: string;
  tahun?: string;
  Status?: string;
  BuCode?: string;
  SubBuCode?: string;
  DeptCode?: string;
  CourseId?: string;
  Program?: string;
  SectionName?: string;
  SectionCode?: string;
  status?: string;
}

interface GetKnowledgeImprovementChart extends GetChart {
  Year: string;
  Month: string;
}

interface GetChartMostFavorite extends GetChart {
  TypeEnrol: string;
  StartDate: string;
  EndDate: string;
}

export const getDataStructure = (binusianId: string) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardexecutive.getDataStructure,
    { BinusianId: binusianId, EmployeeCategory: '' }
  );
};

export const getChartPlanCompletion = ({
  StartDate,
  EndDate,
  Bulan,
  SubBuName,
  BinusianId,
  Tahun,
  DeptName,
  Role,
  BuCode,
  BuName,
  SubBuCode,
  DeptCode,
  SectionCode
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardexecutive.chartPlanCompletionTraining,
    {
      StartDate,
      EndDate,
      Month: Bulan,
      SubBuName,
      BinusianId,
      Year: Tahun,
      DeptName,
      Role,
      BuName,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode
    }
  );
};

export const requestDownloadDataChartPlanTraining = ({
  StartDate,
  EndDate,
  BuName,
  BinusianId,
  Bulan,
  SubBuName,
  Tahun,
  Status,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  SectionName
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardexecutive.downloadDataChartPlanTraining,
    {
      StartDate,
      EndDate,
      BuName,
      BinusianId,
      Month: Bulan,
      SubBuName,
      Year: Tahun,
      Status,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode,
      SectionName
    }
  );
};

export const getChartCompletionRate = ({
  StartDate,
  EndDate,
  Bulan,
  SubBuName,
  BinusianId,
  Tahun,
  DeptName
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardexecutive.completionRateCourse,
    {
      StartDate,
      EndDate,
      Month: Bulan,
      SubBuName,
      BinusianId,
      Year: Tahun,
      DeptName
    }
  );
};

export const requestDownloadDataChartMostCompleted = ({
  StartDate,
  EndDate,
  Bulan,
  SubBuName,
  BinusianId,
  Tahun,
  DeptName
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardexecutive.downloadDataChartCompletionRate,
    {
      StartDate,
      EndDate,
      Month: Bulan,
      SubBuName,
      BinusianId,
      Year: Tahun,
      DeptName
    }
  );
};

export const getChartCompletionRateProgram = ({
  StartDate,
  EndDate,
  BinusianId,
  Year,
  Month,
  BuName,
  SubBuName,
  DeptName,
  SectionName,
  Program,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardexecutive.completionRateProgram,
    {
      StartDate,
      EndDate,
      Month,
      Program,
      BinusianId,
      Year,
      DeptName,
      SectionName,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode
    }
  );
};

export const downloadChartCompletionRateProgram = ({
  StartDate,
  EndDate,
  BinusianId,
  Year,
  Month,
  BuName,
  SubBuName,
  DeptName,
  SectionName,
  Program,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  status
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardexecutive.downloadCompletionRateProgram,
    {
      StartDate,
      EndDate,
      Month,
      Program,
      BinusianId,
      Year,
      DeptName,
      SectionName,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode,
      status
    }
  );
};

// export const getMostCompletedCourses = ({
//   StartDate,
//   EndDate,
//   CategoryId
// }: GetMostCourses) => {
//   return HttpService.post(
//     ApiService.icdc.module.dashboardexecutive.mostCompletedCourse,
//     { StartDate, EndDate, CategoryId }
//   );
// };

// export const getMostFavoriteCourses = ({ StartDate, EndDate }: GetChart) => {
//   return HttpService.post(
//     ApiService.icdc.module.dashboardexecutive.mostFavoriteCourse,
//     { StartDate, EndDate }
//   );
// };

// export const getChartSatisfactoryReport = ({
//   StartDate,
//   EndDate
// }: GetChart) => {
//   return HttpService.post(
//     ApiService.icdc.module.dashboardexecutive.statifactoryReport,
//     { StartDate, EndDate }
//   );
// };

// export const getChartCompletionEmployee = ({
//   StartDate,
//   EndDate,
//   BuName,
//   Bulan,
//   SubBuName,
//   Tahun
// }: GetChartPlan) => {
//   return HttpService.post(
//     ApiService.icdc.module.dashboardexecutive.completionEmployee,
//     { StartDate, EndDate, BuName, Bulan, SubBuName, Tahun }
//   );
// };

export const getChartKnowledgeImprovement = ({
  StartDate,
  EndDate,
  Bulan,
  SubBuName,
  BinusianId,
  Tahun,
  DeptName,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardexecutive.knowledgeImprovement,
    {
      StartDate,
      EndDate,
      Month: Bulan,
      SubBuName,
      BinusianId,
      Year: Tahun,
      DeptName,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode
    }
  );
};

export const getDownloadKnowledgeImprovement = ({
  StartDate,
  EndDate,
  Bulan,
  SubBuName,
  BinusianId,
  Tahun,
  DeptName,
  Status,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  status
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardexecutive.downloadKnowledgeImprovement,
    {
      StartDate,
      EndDate,
      Month: Bulan,
      SubBuName,
      BinusianId,
      Year: Tahun,
      DeptName,
      Status,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode,
      status
    }
  );
};

export const getChartSatisfactoryReport = ({
  StartDate,
  EndDate,
  Month,
  Year,
  BuName,
  SubBuName,
  DeptName,
  SectionName,
  BinusianId,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardexecutive.satisfactoryReport,
    {
      StartDate,
      EndDate,
      Month,
      Year,
      BuName,
      SubBuName,
      DeptName,
      SectionName,
      BinusianId,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode
    }
  );
};

export const requestDownloadSatisfactoryReport = ({
  StartDate,
  EndDate,
  Month,
  Year,
  BuName,
  SubBuName,
  DeptName,
  SectionName,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  BinusianId,
  status
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardexecutive.downloadSatisfactoryReport,
    {
      StartDate,
      EndDate,
      Month,
      Year,
      BuName,
      SubBuName,
      DeptName,
      SectionName,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode,
      BinusianId,
      status
    }
  );
};

export const getChartBudgetRealization = ({
  StartDate,
  EndDate,
  Month,
  SubBuName,
  BinusianId,
  Year,
  BuName,
  DeptName,
  Role,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  SectionName
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardexecutive.budgetRealization,
    {
      StartDate,
      EndDate,
      Month,
      BuName,
      SubBuName,
      BinusianId,
      Year,
      DeptName,
      Role,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode,
      SectionName
    }
  );
};

export const getDownloadBudgetRealization = ({
  StartDate,
  EndDate,
  BuName,
  Month,
  Year,
  SubBuName,
  DeptName,
  BinusianId,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  SectionName,
  status
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardexecutive.downloadBudgetRealization,
    {
      StartDate,
      EndDate,
      BuName,
      Month,
      Year,
      SubBuName,
      DeptName,
      BinusianId,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode,
      SectionName,
      status
    }
  );
};

export const getChartLearningEngagement = ({
  StartDate,
  EndDate,
  BuName,
  Month,
  Year,
  SubBuName,
  DeptName,
  BinusianId,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  SectionName
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardexecutive.learningEnggement,
    {
      StartDate,
      EndDate,
      BinusianId,
      BuName,
      Month,
      Year,
      SubBuName,
      DeptName,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode,
      SectionName
    }
  );
};

export const requestDownloadDataChartLearningEngagement = ({
  StartDate,
  EndDate,
  Status,
  BinusianId,
  Year,
  Month,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardexecutive.downloadLearningEngagement,
    {
      StartDate,
      EndDate,
      Status,
      BinusianId,
      Year,
      Month,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode
    }
  );
};

// export const requestDownloadDataChartEmployee = ({
//   StartDate,
//   EndDate
// }: GetChartPlan) => {
//   return HttpService.post(
//     ApiService.icdc.module.dashboardexecutive.downloadDataChartCompletionEmployee,
//     { StartDate, EndDate }
//   );
// };

// export const requestDownloadSatisfaction = ({
//   StartDate,
//   EndDate
// }: GetChartPlan) => {
//   return HttpService.post(
//     ApiService.icdc.module.dashboardexecutive.downloadDataChartSatisfactionReport,
//     { StartDate, EndDate }
//   );
// };

// export const requestDownloadDataChartMostFavoriteCourse = ({
//   StartDate,
//   EndDate,
//   TypeEnrol
// }: GetChartMostFavorite) => {
//   return HttpService.post(
//     ApiService.icdc.module.dashboardexecutive.downloadDataChartMostFavoriteCourse,
//     { StartDate, EndDate, TypeEnrol }
//   );
// };

interface PostWidget {
  binusianId: string;
  data: WidgetConfig[];
}

export const postWidgetConfiguration = (data: PostWidget) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardexecutive.postWidgetConfiguration,
    { binusianID: data.binusianId, data: data.data }
  );
};

interface ParamsConfig {
  binusianId: string;
}

export const getConfigDashboardBCLD = ({ binusianId }: ParamsConfig) => {
  return HttpService.get(
    `${ApiService.icdc.module.dashboardexecutive.dashboardWidgetConfiguration}?binusianId=${binusianId}`
  );
};
